import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <section className="newsletter-section">
          <p className="newsletter-title">admin@mangoes.live</p>
        </section>

        <section className="social-section">
          <nav aria-label="Social media">
            <ul>
              {[
                { name: "Instagram", url: "https://www.instagram.com/" },
                { name: "Facebook", url: "https://www.facebook.com/" },
                { name: "Youtube", url: "https://www.youtube.com/" },
                { name: "Tiktok", url: "https://www.tiktok.com/" },
                { name: "Spotify", url: "https://www.spotify.com/" },
                { name: "Pinterest", url: "https://www.pinterest.com/" },
                { name: "X", url: "https://x.com/" },
                { name: "Linkedin", url: "https://www.linkedin.com/" },
              ].map((item) => (
                <li key={item.name}>
                  <a href={item.url} target="_blank" rel="noopener noreferrer">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </section>

        <section className="links-section">
          <div className="link-column">
            <p className="column-title">Help</p>
            <Link to="/shipping" onClick={toTop}>
              Shipping
            </Link>
            <Link to="/returns" onClick={toTop}>
              Returns
            </Link>
            <Link to="/blog" onClick={toTop}>
              Blog
            </Link>
            <Link to="/tracking-order" onClick={toTop}>
              Tracking Order
            </Link>
          </div>
        </section>

        <section className="footer-bottom">
          <div className="legal-links">
            <Link to="/privacy" onClick={toTop}>
              Privacy Policy and Cookies
            </Link>
            <Link to="/terms" onClick={toTop}>
              Terms and Conditions
            </Link>
          </div>
          <span className="copyright">© 2025 Mystron Technology Limited All rights reserved</span>
        </section>
      </div>
    </footer>
  );
}

export default Footer;
